import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../redux/slices/authSlice';
import { landingRouteFor } from './routeConfig';

const PublicRoute = ({ children }) => {
  const user = useSelector(selectUser);

  if (user) {
    return <Navigate to={landingRouteFor(user.userType)} replace />;
  }

  return children;
};

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default PublicRoute;
